/*<!-------------------------------------
|   Author: Kartik Mukati           |
|   Date: 19-04-2023                   |
--------------------------------------->*/

import { Component, OnInit } from '@angular/core';
import { ConfLobControlService } from 'src/app/configurator-app/Conf-Shared/Services/conf-lob-service/conf-lob-control.service' //'../Conf-Shared/Services/conf-lob-service/conf-lob-control.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Store } from '@ngrx/store';
import * as actions from '../../conf-store/action/index'
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-conf-introductory-layout',
  templateUrl: './conf-introductory-layout.component.html',
  styleUrls: ['./conf-introductory-layout.component.scss']
})
export class ConfIntroductoryLayoutComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private _dataLobService: ConfLobControlService, private store: Store, private router: Router, private cookie_service: CookieService) {
    this.selectedLob = this.activatedRoute.snapshot.params['lob'];
  }

  showGetStart: boolean = false;
  selectedLob: string = '';
  progress_step_arr: any = [];
  lobMsg: any = "";
  selectedLobObj: any = { 'lob_selected': '', 'current_step': '', 'next_step': '' }
  videosrc: any = ""
  confAWSUrlStr: any = environment.confAWSurl

  ngOnInit(): void {
    this.store.dispatch(actions.resetAllState())
    if (this.selectedLob == '' || this.selectedLob == undefined) {
      this.showGetStart = false
      this.selectedLob = ""

    } else {
      this.showGetStart = true;
      if (this.selectedLob.toLocaleLowerCase() != 'hcv') {
        this.lobMsg = "Choose a vehicle that best suits <br>  your requirement"
      } else {
        this.lobMsg = "Build Your Truck"
      }

      this.videosrc = this.confAWSUrlStr + "/public_images/common/lob_landing.webm";
    }

    // let conf_id = this.cookie_service.get("configuration_id");
    // if (conf_id != "" && conf_id != undefined) {
    //   this.cookie_service.set("configuration_id", "")
    // }


  }


  routeToOSP() {
    this.store.dispatch(actions.resetAllState())
    this.router.navigateByUrl('/home');
  }

  start_configurator(selectedLob: any) {
    // *************************************************
    // **  PASSING DATA BETWEEN SIBLING COMPONENT ******
    // *************************************************

    let lobName: any = "";
    let entryPoint: any = ""

    if (selectedLob == 'hcv') {
      lobName = "Heavy Trucks"
      entryPoint = "hcv-fuel-type"
    } else if (selectedLob == 'ilmcv') {
      lobName = "Light, Intermediate and Medium Duty Trucks"
      entryPoint = "ilmcv-fuel-type"
    } else if (selectedLob == 'scv') {
      lobName = "SCV Cargo & Pickups"
      entryPoint = "scv-fuel-type"  //changed by dk
    } else if (selectedLob == 'magic') {
      lobName = "Magic"
      entryPoint = "magic-roof-type"
    } else if (this.selectedLob == 'bus') {
      lobName = "Buses"
      entryPoint = "bus-fuel-type"
    } else {
      lobName = "Winger"
      entryPoint = "winger-application"
    }

    let eventObject: any = {};
    eventObject['Category'] = lobName;
    this._dataLobService.saveCleverTapEvt('CV Configurator initiated', eventObject)

    this.router.navigate(['/configurator/' + selectedLob + '/' + entryPoint]);
  }

  lobSelected(lobName: string) {
    this.selectedLob = lobName.toLowerCase()
    this.showGetStart = false;

    let lobNameDesc: any = "";

    if (this.selectedLob == 'hcv') {
      lobNameDesc = "Heavy Trucks"
    } else if (this.selectedLob == 'ilmcv') {
      lobNameDesc = "Light, Intermediate and Medium Duty Trucks"
    } else if (this.selectedLob == 'bus') {
      lobNameDesc = "Buses"
    } else if (this.selectedLob == 'winger') {
      lobNameDesc = "Winger"
    } else if (this.selectedLob == 'magic') {
      lobNameDesc = "Magic"
    }
    else {
      lobNameDesc = "SCV Cargo & Pickups"
    }

    let eventObject: any = {};
    eventObject['Category'] = lobNameDesc;
    this._dataLobService.saveCleverTapEvt('CV Configurator Selected',eventObject)
    this.router.navigate(['/intro/' + this.selectedLob + '/']);

  }

  routeToTml() {
    // Converts the route into a string that can be used
    // with the window.open() function

    window.open("https://www.tatamotors.com/", "_blank");
  }
}
